export enum ForwardingStatus {
  Completed = "Completed",
  NotStarted = "NotStarted",
  Pending = "Pending",
  NotApplicable = "NotApplicable",
}

export function forwardingStatusToDisplayText(forwardingStatus: ForwardingStatus) {
  switch (forwardingStatus) {
    case ForwardingStatus.Completed:
      return "Completed";
    case ForwardingStatus.NotStarted:
      return "Not started";
    case ForwardingStatus.Pending:
      return "Pending";
    case ForwardingStatus.NotApplicable:
      return "N/A";
  }
}
